<template>
  <Modal title="赠送会员卡" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="formInfo"  :model='formInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
          <FormItem label="会员卡："  prop="card_id">
            <Select v-model="formInfo.card_id" class="perW100">
              <Option :value="0">请选择</Option>
              <Option v-for="item in cardInfo" :value="item.system_card_detail_id" :key="item.system_card_detail_id">
                {{item.title}}
              </Option>
            </Select>
          </FormItem>
          <form-item label="姓名" prop="username">
            <Input placeholder="请输入姓名" v-model="formInfo.username"></Input>
          </form-item>
          <form-item label="身份证号" prop="idcard">
            <Input placeholder="请输入身份证号" v-model="formInfo.idcard"></Input>
          </form-item>
          <form-item label="手机号" prop="phone">
            <Input placeholder="请输入手机号" v-model="formInfo.phone"></Input>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('formInfo')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { getAllCard, sendCard } from '@/api/user'
export default {
  name: 'sendCardEdit',
  data () {
    return {
      isShow: false,
      cardInfo: [],
      formInfo: {
        user_id: 0,
        card_id: 0,
        username: '',
        idcard: '',
        phone: ''
      },
      ruleValidate: {
        card_id: [
          { required: true, message: '请选择会员卡', trigger: 'change', type: 'number', min: 1 }
        ],
        username: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getAllCard()
  },
  methods: {
    handle (status) {
      this.isShow = false
    },
    init () {
      this.formInfo = {
        user_id: 0,
        card_id: 0,
        username: '',
        idcard: '',
        phone: ''
      }
    },
    handleOk (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          sendCard(this.formInfo).then(res => {
            let msg = '发放成功'
            if (res.code === 200) {
              this.$Message.success(msg)
              this.isShow = false
              this.$emit('closeModal')
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },
    getAllCard () {
      getAllCard().then(res => {
        this.cardInfo = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
